import LeeCoreLexEpicClient from 'bundles/epic/clients/leeCoreLex';

/*
 * This file includes utilities to check whether specific features should be enabled in the ondemand bundle.
 */

/**
 * This is used to determine whether we should enable freemium load testing.
 */
export const shouldEnabledFreemiumLoadTesting = () => LeeCoreLexEpicClient.get('freemiumLoadTesting');
